import {useEffect, useState} from "react";
import FieldError from "@/components/FieldError";
import {useValidation} from "@/validation";

export default function Input({label, name, type, value, description, placeholder, disabled, required, onChange, min, max, inputMode, pattern, maxLength}) {
    const {isFieldValid, invalidMessage, showErrors} = useValidation()

    const [touched, setTouched] = useState(false)

    const valid = isFieldValid(name)
    const invalidMsg = invalidMessage(name)
    const showError = touched && !valid && invalidMsg

    const handleChange = (e) => {
        onChange && onChange(e.target.value)
    }

    useEffect(() => {
        if (showErrors) {
            setTouched(true)
        }
    }, [showErrors])

    return (
        <fieldset className="daisy-fieldset">
            {label && <legend className="daisy-fieldset-legend text-label inline">
                {label}{required && ' *'}
                {description && <span className={"input-description"}> {description}</span>}
            </legend>}
            <input
                type={type || 'text'}
                name={name}
                className={`daisy-input w-full ${!showError ? 'daisy-input-neutral' : 'daisy-input-error'}`}
                value={value || ''}
                placeholder={placeholder}
                onChange={handleChange}
                disabled={disabled}
                min={min}
                max={max}
                inputMode={inputMode}
                pattern={pattern}
                maxLength={maxLength}
            />
            {showError && (
                <FieldError message={invalidMsg} />
            )}
        </fieldset>
    )
}
